import { FC } from 'react'
import { SUPPORT_EMAIL } from '../utils/shared/constants';
import { AdvancedButton } from '../components/AdvancedButton';

interface IProps { }

export const HelpPage: FC<IProps> = (props) => {
    const handleOpenChat = () => {
        (window as any).beaverChat?.open();
    }

    return (
        <div className='d-flex flex-column gap-3'>
            <h3>Help & Support</h3>
            <p>Have a question or ran into an issue? We're happy to help.</p>

            <div className='d-flex flex-column gap-5'>
                <div className='d-flex align-items-center gap-3'>
                    <i className='bi bi-envelope h4 m-0 text-primary' />
                    <div className='flex-grow-1'>
                        <div className='fw-bold'>Email us</div>
                        <div className='text-muted small'>We'll get back to you as soon as we can.</div>
                    </div>
                    <a href={`mailto:${SUPPORT_EMAIL}`}>
                        <AdvancedButton variant='outline-primary'>{SUPPORT_EMAIL}</AdvancedButton>
                    </a>
                </div>

                <div className='d-flex align-items-center gap-3'>
                    <i className='bi bi-chat-dots h4 m-0 text-primary' />
                    <div className='flex-grow-1'>
                        <div className='fw-bold'>Chat with us</div>
                        <div className='text-muted small'>Get a quick answer when we're online.</div>
                    </div>
                    <AdvancedButton variant='outline-primary' onClick={handleOpenChat}>Open chat</AdvancedButton>
                </div>
            </div>
        </div>
    )
}
